export default __webpack_public_path__ + "static/media/furniture.e9d9e0c1.jpg";